<template>
    <div>
        <div class="tabulation-title mb-4">
            <h5>
                <v-icon color="primary">label_outline</v-icon> Localisation
            </h5>
        </div>

        <div class="mr-auto ml-auto">
            <v-text-field v-if="provider.localisation.address !== undefined" autocomplete="new-address"
                v-model="provider.localisation.address" label="Adresse" outlined>
            </v-text-field>

            <v-text-field v-if="provider.localisation.postal_code !== undefined"
                          v-model="provider.localisation.postal_code" label="Code postal" outlined>
            </v-text-field>

            <v-autocomplete v-model="provider.localisation.commune"
                :items="communes" label="Ville" item-text="name" return-object :loading="loadingCommunes"
                :search-input.sync="searchCommunes" no-data-text="Saisissez pour sélectionner une ville" outlined>
            </v-autocomplete>
        </div>
    </div>
</template>

<script>
import _ from "lodash-es"
import {mapState} from "vuex"

export default {
    name: "Localisation",
    props: ["provider"],
    data() {
        return {
            loadingCommunes: false,
            communes: [],
            searchCommunes: null
        }
    },
    methods: {
        getCommunes: _.debounce(function () {
            this.loadingCommunes = true

            let payload = {
                search: this.searchCommunes,
                accountId: this.account.id,
            }

            this.$http.post('resource/communes', payload).then(res => {
                this.communes = res.body.data.communes

                this.loadingCommunes = false
            })
        }, 500),
    },
    watch: {
        searchCommunes() {
            if (this.searchCommunes !== null && this.searchCommunes !== undefined) {
                this.searchCommunes = this.searchCommunes.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase()
            }

            this.getCommunes()
        }
    },
    computed: {
        ...mapState('account', ['user', 'account']),
    },
    created() {
        if (this.provider.localisation.commune !== undefined) {
            this.searchCommunes = this.provider.localisation.name

            this.communes.push(this.provider.localisation.commune)
        }
    }
}
</script>